module.exports = __webpack_public_path__ + "files/56344e371c145e32219783226c15386c.png";